<template>
  <div class="dropdown" :class="{'is-active' : isOpen, 'is-right' : isRight}">
    <div class="dropdown-trigger">
      <button class="button has-text-primary" @click="isOpen = !isOpen">
        <slot name="trigger">
          <span>{{title}}</span>
        </slot>
        <span class="icon is-small">
          <fa-icon class="caret" :icon="faCaretDown" />
        </span>
      </button>
    </div>
    <div class="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { faCaretDown } from "@fortawesome/free-solid-svg-icons"

export default {
  props: {
    title: String,
    isRight: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      faCaretDown
    }
  },
  methods: {
    handleClickOutside(e) {
      if (e.target === this.$el || this.$el.contains(e.target))
        return

      this.isOpen = false;
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);

    this.$once("hook:beforeDestroy", () => {
      document.removeEventListener("click", this.handleClickOutside);
    });
  }
}
</script>

<style lang="sass" scoped>
.dropdown
  margin-top: 25px
  cursor: pointer
.caret
  margin-left: -10px
.button
  border: none !important
  box-shadow: none !important
@media (max-width: 576px)
  .dropdown
    margin-top: 8px
</style>